"use strict";const e={version:"2.9.0",major:2,minor:9,patch:0,suffix:"",isNext:!1,buildTime:1743779257};export default e;
//# sourceMappingURL=VersionInfo.js.map
